import Cookies from 'js-cookie'

const TokenKey = 'Speakey_token'

export function getToken() {
  let searchParams = new URLSearchParams(window.location.search)
  let token = searchParams.get('token')

  if (token) {
    // 清除url中的token参数
    let reg = /\?token=.+/
    let url = window.location.href
    if (reg.test(url)) {
        url = url.replace(reg, "")
        history.replaceState({}, '', url)
    }
    setToken(token)
  } else {
    token = Cookies.get(TokenKey)
  }

  return token
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}